import { Spinner } from "@components/ui-kit";
import { useGetContractorsLazyQuery } from "@src/__generated__/graphql";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { getParamFromQuery } from "@src/utils/url";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { CardListContractors } from "./CardListContractors";
import { StoreContractors } from "./StoreContractors";

// context holding page related data
export const PageContractorsCtx = React.createContext<StoreContractors>(
  null as any as StoreContractors,
);

/**
 * encapsulate initial data fetch & refetch
 */
function useData(store: StoreContractors) {
  const [fetchContractors, { loading, error, refetch }] =
    useGetContractorsLazyQuery({
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        store.fromGetContractorsQuery(data);
      },
    });

  useEffect(() => {
    fetchContractors({ variables: store.queryVariables });
  }, [store.queryVariables]);

  store.refetch = refetch;

  return { loading, error };
}

export const PageContractors = withCan(
  { do: "contractor_read" },
  observer(function PageContractors() {
    const { query } = useRouter();

    const [store] = useState(() => {
      const store = StoreContractors.create();
      store.searchTerm = getParamFromQuery("search", query) ?? "";
      store.orderBy.fromURLSearchParam(query);
      return store;
    });

    useUpdateURI(store.searchParams);

    const { loading } = useData(store);

    return (
      <PageContractorsCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            {loading && <Spinner absolute />}
            <CardListContractors />
          </div>
        </div>
      </PageContractorsCtx.Provider>
    );
  }),
);
